var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 1104,
    viewBox: "0 0 540 1104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4621_4482)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 1104,
    fill: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448.244 -53H686L443.756 246H206L448.244 -53ZM215.722 258L220.583 264H458.339L453.478 258H215.722ZM468.062 276H230.305L235.166 282H472.923L468.062 276ZM482.645 294H244.889L249.75 300H487.506L482.645 294ZM497.228 312H259.472L264.333 318H502.089L497.228 312ZM511.811 330H274.055L278.916 336H516.672L511.811 330ZM526.395 348H288.638L293.499 354H531.256L526.395 348ZM540.978 366H303.222L308.083 372H545.839L540.978 366ZM555.561 384H317.805L322.666 390H560.422L555.561 384ZM570.144 402H332.388L337.249 408H575.005L570.144 402ZM584.728 420H346.971L351.832 426H589.589L584.728 420ZM599.311 438H361.555L366.416 444H604.172L599.311 438ZM613.894 456H376.138L380.999 462H618.755L613.894 456ZM628.477 474H390.721L395.582 480H633.338L628.477 474ZM643.06 492H405.304L410.165 498H647.922L643.06 492ZM657.644 510H419.888L424.749 516H662.505L657.644 510ZM672.227 528H434.471L439.332 534H677.088L672.227 528Z",
    fill: "url(#paint0_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 836H83.4117L-69 1024L83.4117 1212H233L80.5882 1024L233 836Z",
    fill: "url(#paint1_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 -240H484.795L291 9.53674e-06L484.795 240H675L481.205 9.53674e-06L675 -240Z",
    stroke: "url(#paint2_radial_4621_4482)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 776H499.486L393 907.565L499.486 1039.13H604L497.514 907.565L604 776Z",
    stroke: "url(#paint3_radial_4621_4482)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 458H196.693L-148 883.5L196.693 1309H535L190.307 883.5L535 458Z",
    stroke: "url(#paint4_radial_4621_4482)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 -17H102.281L-90 220.5L102.281 458H291L98.7189 220.5L291 -17Z",
    stroke: "url(#paint5_radial_4621_4482)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.35 1024L-296 191H-56.3498L618 1024H378.35Z",
    fill: "url(#paint6_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.055,
    y: 685.818,
    width: 20,
    height: 494.03,
    transform: "rotate(140.955 553.055 685.818)",
    fill: "url(#paint7_linear_4621_4482)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.951,
    y: 724,
    width: 20,
    height: 478.385,
    transform: "rotate(38.696 269.951 724)",
    fill: "url(#paint8_linear_4621_4482)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 486L27.4812 497.696H259.345L249.864 486H18Z",
    fill: "url(#paint9_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.308 521.087H46.4437L55.9249 532.783H287.789L278.308 521.087Z",
    fill: "url(#paint10_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.751 556.174H74.8873L84.3685 567.87H316.232L306.751 556.174Z",
    fill: "url(#paint11_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.195 591.261H103.331L112.812 602.957H344.676L335.195 591.261Z",
    fill: "url(#paint12_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.639 626.348H131.775L141.256 638.043H373.12L363.639 626.348Z",
    fill: "url(#paint13_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.082 661.435H160.218L169.699 673.13H401.563L392.082 661.435Z",
    fill: "url(#paint14_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.526 696.522H188.662L198.143 708.217H430.007L420.526 696.522Z",
    fill: "url(#paint15_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.97 731.609H217.106L226.587 743.304H458.451L448.97 731.609Z",
    fill: "url(#paint16_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.413 766.696H245.549L255.03 778.391H486.894L477.413 766.696Z",
    fill: "url(#paint17_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.857 801.783H273.993L283.474 813.478H515.338L505.857 801.783Z",
    fill: "url(#paint18_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.3 836.87H302.437L311.918 848.565H543.782L534.3 836.87Z",
    fill: "url(#paint19_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.744 871.957H330.88L340.361 883.652H572.225L562.744 871.957Z",
    fill: "url(#paint20_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.188 907.043H359.324L368.805 918.739H600.669L591.188 907.043Z",
    fill: "url(#paint21_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.631 942.13H387.768L397.249 953.826H629.113L619.631 942.13Z",
    fill: "url(#paint22_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.075 977.217H416.211L425.692 988.913H657.556L648.075 977.217Z",
    fill: "url(#paint23_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.519 1012.3H444.655L454.136 1024H686L676.519 1012.3Z",
    fill: "url(#paint24_linear_4621_4482)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.947,
    y: 744.727,
    width: 20,
    height: 445.15,
    transform: "rotate(140.955 245.947 744.727)",
    fill: "url(#paint25_linear_4621_4482)",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4621_4482",
    x1: 446,
    y1: -53,
    x2: 446,
    y2: 545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4621_4482",
    x1: 82,
    y1: 836,
    x2: 82,
    y2: 1212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F48120"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4621_4482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(282.5 1.82425e-05) scale(303.5 306.058)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4621_4482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(388.329 907.565) scale(166.767 167.777)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4621_4482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-163.119 883.5) scale(539.819 542.616)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4621_4482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-90 221.286) scale(316.898 318.731)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4621_4482",
    x1: 40.0477,
    y1: -642,
    x2: 40.0477,
    y2: 1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4621_4482",
    x1: 563.055,
    y1: 685.818,
    x2: 563.055,
    y2: 1179.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBA83"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4621_4482",
    x1: 279.951,
    y1: 724,
    x2: 279.951,
    y2: 1202.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBA83"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4621_4482",
    x1: 467.142,
    y1: -120.225,
    x2: 467.142,
    y2: 1045.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4621_4482",
    x1: 467.142,
    y1: -120.225,
    x2: 467.142,
    y2: 1045.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4621_4482",
    x1: 467.142,
    y1: -120.225,
    x2: 467.142,
    y2: 1045.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4621_4482",
    x1: 467.142,
    y1: -120.225,
    x2: 467.142,
    y2: 1045.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4621_4482",
    x1: 467.142,
    y1: -120.225,
    x2: 467.142,
    y2: 1045.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4621_4482",
    x1: 467.142,
    y1: -120.225,
    x2: 467.142,
    y2: 1045.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4621_4482",
    x1: 467.142,
    y1: -120.225,
    x2: 467.142,
    y2: 1045.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4621_4482",
    x1: 467.142,
    y1: -120.225,
    x2: 467.142,
    y2: 1045.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4621_4482",
    x1: 467.142,
    y1: -120.225,
    x2: 467.142,
    y2: 1045.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4621_4482",
    x1: 467.142,
    y1: -120.225,
    x2: 467.142,
    y2: 1045.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4621_4482",
    x1: 467.142,
    y1: -120.225,
    x2: 467.142,
    y2: 1045.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4621_4482",
    x1: 467.142,
    y1: -120.225,
    x2: 467.142,
    y2: 1045.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4621_4482",
    x1: 467.142,
    y1: -120.225,
    x2: 467.142,
    y2: 1045.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4621_4482",
    x1: 467.142,
    y1: -120.225,
    x2: 467.142,
    y2: 1045.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4621_4482",
    x1: 467.142,
    y1: -120.225,
    x2: 467.142,
    y2: 1045.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4621_4482",
    x1: 467.142,
    y1: -120.225,
    x2: 467.142,
    y2: 1045.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4621_4482",
    x1: 255.947,
    y1: 744.727,
    x2: 255.947,
    y2: 1189.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBA83"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4621_4482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 1104,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundOnboarding);
export default __webpack_public_path__ + "static/media/backgroundOnboarding.5b48cca1395cd9c2b7c345ec0cee8281.svg";
export { ForwardRef as ReactComponent };